export default class PlayListAudio {
    // 监听结束事件的计时器属性
    time = null
    //播放地址(用于判断当前播放的一个标识)
    audiourl = "";
    constructor() {
        // 实例化播放器的属性
        this.innerAudioContext = new Audio(); 
    };
    // 播放和暂停
    play(url) {
        if (this.audiourl == url) {
            this.audiourl = "";
            this.innerAudioContext.pause();
        } else {
            this.audiourl = url;
            this.innerAudioContext.src = url;
            this.innerAudioContext.play();
            this.monitorPlay()
        }
    };
    // 停止播放
    stop() {
        this.audiourl = "";
        this.innerAudioContext.pause();
        this.innerAudioContext.src = '';
    };
    // 监听到播放停止时候清空audiourl(方便实例化对象了解到结束事件)
    monitorPlay() {
        this.time = setInterval(() => {
            if (this.innerAudioContext.ended) {
                this.audiourl = ""
                clearInterval(this.time)
            }
        }, 1000)
    }
}


// WEBPACK FOOTER //
// ./src/utils/PlayListAudio.js